import React, { useEffect, useRef } from 'react';
import {
  chakra, Button, useColorMode, useColorModeValue, useMediaQuery,
} from '@chakra-ui/react';
import { MoonIcon } from '@chakra-ui/icons';

const ThemeButton = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const focusBorderColorInput = useColorModeValue({ boxShadow: '0 0 0 3px #3B82F6' }, { boxShadow: '0 0 0 3px orange' });
  const ThemeButtonRef = useRef(null);
  const [isMoreThan420px] = useMediaQuery('(max-width: 420px)');
  const HandleKeyDownThemeIcon = (event) => {
    if (event.key === 'X' && event.ctrlKey) {
      event.preventDefault();
      ThemeButtonRef.current.click();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', HandleKeyDownThemeIcon);
    return () => {
      document.removeEventListener('keydown', HandleKeyDownThemeIcon);
    };
  }, []);

  return (
    <Button
      ref={ThemeButtonRef}
      _focus={focusBorderColorInput}
      focusBorderColor={focusBorderColorInput}
      boxShadow="lg"
      outline="none"
      outlineColor="initial"
      style={{ outlineStyle: 'none' }}
      m="4"
      mr={
      isMoreThan420px
        ? '4'
        : '-1'
      }
      rounded="xl"
      onClick={toggleColorMode}
      title="Switch theme button"
    >
      {colorMode === 'light'
        ? <MoonIcon />
        : (
          <chakra.svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" aria-hidden="true" focusable="false" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
            <path d="M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z" />
          </chakra.svg>
        )}
    </Button>
  );
};

export default ThemeButton;
